var footerInit;

(function ($) {

	const selectors = {
		container: '.c-footer',
	}

	footerInit = function () {
		$(selectors.container).each((i, el) => {
			new Footer(el);
		});
	}

	class Footer {
		constructor(element) {
			this.$wrap = $(element);

			this.init();

		}
		init() {

			$('.c-footer__nav', this.$wrap).attr('data-accordions', '');
			$('.c-footer__nav > li ', this.$wrap).attr('data-accordion', '');
			$('.c-footer__nav > li > a', this.$wrap).attr('data-accordion-trigger', '');
			$('.c-footer__nav > li > .sub-menu', this.$wrap).attr('data-accordion-content', '');


		}
	}
})(jQuery);


export default footerInit;